import {useHostSelector} from 'hooks/hostHooks/hostHooks';
import {isUhcEnabled} from 'libs/rollout';
import {getFax, getPhones, getPrescriptionEmail} from 'selectors/storeInfo';

import {useIsCartPage} from '../useIsCartPage/useIsCartPage';
import {useIsUhcPage} from '../useIsUhcPage/useIsUhcPage';

/**
 * A custom hook that retrieves storeInfo values.
 *
 * @returns {Object} An object containing the following properties:
 *  - `email` (string): The prescription email.
 *  - `phones` (Object): An object containing phone numbers.
 *  - `fax` (string): The fax number.
 *  - `actualPhoneNumber` (string): The actual phone number to use.
 */
export const useGetStoreInfoValues = () => {
    const {isCartPage} = useIsCartPage();
    const {isUhcPage} = useIsUhcPage();
    const prescriptionEmail = useHostSelector(store => getPrescriptionEmail(store));
    const phones = useHostSelector(store => getPhones(store));
    const fax = useHostSelector(store => getFax(store));
    const actualPhoneNumber =
        isUhcEnabled() || isUhcPage ? phones.uhc : (isCartPage && phones.cart) || phones.default;

    return {
        actualPhoneNumber,
        fax,
        phones,
        prescriptionEmail,
    };
};
